import { render, staticRenderFns } from "./TransferUserAgentsForm.vue?vue&type=template&id=88d8d4e6"
import script from "./TransferUserAgentsForm.vue?vue&type=script&lang=js"
export * from "./TransferUserAgentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports